// EmbedChatRoute.js
import EmbedChat from "./components/EmbedChat";

export default function EmbedChatRoute() {
    return (
      <div style={{
        width: '100%',
        height: '100vh',   // make it fill the iframe completely
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <EmbedChat />
      </div>
    );
}



